import { combineReducers } from 'redux';
import workedInLast30Days from 'store/reducers/workedInLast30Days/workedInLast30Days';
import workedInLast30DaysFilters from 'store/reducers/workedInLast30Days/workedInLast30DaysFilters';
import workedInLast30DaysExcel from 'store/reducers/workedInLast30Days/workedInLast30DaysExcel';

export default combineReducers({
  workedInLast30Days,
  workedInLast30DaysFilters,
  workedInLast30DaysExcel
});